/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateCompanyRequestCompany,
  CreateCompanyRequestCompanyFromJSON,
  CreateCompanyRequestCompanyFromJSONTyped,
  CreateCompanyRequestCompanyToJSON
} from './CreateCompanyRequestCompany'

/**
 *
 * @export
 * @interface UpdateCompanyRequest
 */
export interface UpdateCompanyRequest {
  /**
   *
   * @type {CreateCompanyRequestCompany}
   * @memberof UpdateCompanyRequest
   */
  company?: CreateCompanyRequestCompany
}

export function UpdateCompanyRequestFromJSON(json: any): UpdateCompanyRequest {
  return UpdateCompanyRequestFromJSONTyped(json, false)
}

export function UpdateCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompanyRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    company: !exists(json, 'company') ? undefined : CreateCompanyRequestCompanyFromJSON(json['company'])
  }
}

export function UpdateCompanyRequestToJSON(value?: UpdateCompanyRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    company: CreateCompanyRequestCompanyToJSON(value.company)
  }
}
